import { useCallback } from 'react';
import {
    INBOX_CONTAINER
} from '@interlayer/js/components/system/CommunicationWidgets/hooks/useInitWidgets/constants.buzz';

export const useOpenInbox = () => useCallback((event) => {
    event?.preventDefault();

    if (!window.Communication) {
        return;
    }

    const api = window.Communication.API;
    const windowStatus = api?.inbox.getWindowStatus();

    if (windowStatus?.close) {
        document.getElementById(INBOX_CONTAINER)?.classList.remove('ignore-input');
        return api.inbox.showInboxTab();
    }

    if (windowStatus?.hide) {
        api?.chat.minimize();
        document.getElementById(INBOX_CONTAINER)?.classList.remove('ignore-input');

        return api.inbox.maximize();
    }

    if (windowStatus?.open) {
        document.getElementById(INBOX_CONTAINER)?.classList.add('ignore-input');

        return api.inbox.minimize();
    }
}, []);
